module.exports = __webpack_public_path__ + "img/benchmark.c02ab7c4.svg";